import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

// Thunk to get medical file by user ID
export const get_medical_file_by_user_id = createAsyncThunk(
  "medicalFile/get_medical_file_by_user_id",
  async (userId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/get-medical-file-by-user/${userId}`, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to get admin medical files with pagination and search
export const get_admin_medical_file = createAsyncThunk(
  "medicalFile/get_admin_medical_file",
  async (
    { page, perPage, searchId },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/admin/get-admin-medical-file?page=${page}&perPage=${perPage}&searchId=${searchId}`,
        { withCredentials: true }
      );
      console.log(data);
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to generate OTP for file access
export const generate_otp_for_file = createAsyncThunk(
  "medicalFile/generate_otp_for_file",
  async ({ fileId }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/generate-otp", { fileId });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to validate OTP for file access
export const validate_otp_for_file = createAsyncThunk(
  "medicalFile/validate_otp_for_file",
  async ({ fileId, otp }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post("/validate-otp", { fileId, otp });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to create chat data (message or files)
export const create_chatData = createAsyncThunk(
  "medicalFile/create_chatData",
  async (
    { medicalFileId, message, files, senderData },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const formData = new FormData();
      formData.append("message", message || "");
      formData.append("senderData", JSON.stringify(senderData));
      if (files && files.length > 0) {
        files.forEach((file) => formData.append("files", file));
      }
      const { data } = await api.post(
        `/create-chat-data/${medicalFileId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to edit medical file
export const edit_medical_file = createAsyncThunk(
  "medicalFile/edit_medical_file",
  async (
    { medicalFileId, fileData, doctorData },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.put(`/edit-medical-file/${medicalFileId}`, {
        fileData,
        doctorData,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Thunk to delete a medical file
export const delete_medical_file = createAsyncThunk(
  "medicalFile/delete_medical_file",
  async (medicalFileId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(
        `/delete-medical-file/${medicalFileId}`
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const medicalFileReducer = createSlice({
  name: "medicalFile",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    clientMedicalFiles: [],
    adminMedicalFiles: [],
    adminTotalMedicalFiles: 0,
    medicalFile: null,
  },

  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [get_medical_file_by_user_id.fulfilled]: (state, { payload }) => {
      state.clientMedicalFiles = payload.clientMedicalFiles;
    },
    [get_admin_medical_file.pending]: (state) => {
      state.loader = true;
      state.errorMessage = "";
      state.successMessage = "";
    },
    [get_admin_medical_file.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.adminMedicalFiles = payload.adminMedicalFiles;
      state.adminTotalMedicalFiles = payload.adminTotalMedicalFiles;
    },
    [get_admin_medical_file.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.message || "Failed to get medical files.";
    },
    [generate_otp_for_file.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
    },
    [generate_otp_for_file.rejectWithValue]: (state, { payload }) => {
      state.errorMessage = payload.message;
    },
    [validate_otp_for_file.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
      state.accessedMedicalFile = payload.medicalFile;
    },
    [edit_medical_file.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
    },
    [create_chatData.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
    },
    [delete_medical_file.fulfilled]: (state, { payload }) => {
      state.successMessage = payload.message;
    },
  },
});

export const { messageClear } = medicalFileReducer.actions;
export default medicalFileReducer.reducer;
